import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ErrorMessage = ({ message }) => (
    <div className="form-message error" role="alert">
        <FontAwesomeIcon icon={faCircleExclamation} className="message-icon error" size="md" />
        <p className="form-message-text error">{message}</p>
    </div>
);

export default ErrorMessage;
